<template>
  <div v-if="tableDisplay == 'documents'">
    <v-row style="margin-top: -90px">
      <v-spacer></v-spacer>
      <v-col cols="3" class="text-right"> 
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            style="margin-bottom: 20px"
            >
          <template slot="append-outer">
          <dropdown-filter @applyFilter="applyFilter"/>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row class="mb-4 px-3 mt-n2" v-if="selected.length > 0">
      <v-app-bar color="grey darken-3 mb-3" dense dark>
        <v-toolbar-title class="overline"
          >{{ selected.length }} selected</v-toolbar-title
        >
        <v-divider class="mx-4" vertical></v-divider>
        <!-- <v-btn
          depressed
          class="overline mx-4 custom-hover"
          color="grey darken-3"
          >Edit</v-btn
        >
        <v-btn
          depressed
          class="overline mx-4 custom-hover"
          color="grey darken-3"
          >Delete</v-btn
        > -->
        <!-- <v-btn
          depressed
          class="overline mx-4 custom-hover"
          color="grey darken-3"
          @click="initiateToRouteRequest()"
          >Initiate To Route Request</v-btn
        > -->
        <v-btn
          depressed
          class="overline mx-4 custom-hover"
          color="grey darken-3"
          @click="manageDocumentVersions()"
          >Manage Version</v-btn
        >
        <v-btn
          depressed
          class="overline mx-4 custom-hover"
          color="grey darken-3"
          @click="viewDocuments()"
          >View Document</v-btn
        >
      </v-app-bar>
    </v-row>
    <v-row class="mb-n7 mt-n6" v-show="showSuccess">
      <v-col cols="12">
        <v-alert dense text type="success" dismissible>Saved Document</v-alert>
      </v-col>
    </v-row>
    <v-row class="mb-n6 mt-n5" v-show="showRouteSuccess">
      <v-col cols="12">
        <v-alert dense text type="success" dismissible
          >Saved Route Record</v-alert
        >
      </v-col>
    </v-row>
    <RouteModalCreate
      :dialog="route_dialog"
      :fromDocument="true"
      @closeDialog="closeRouteDialog"
    />
    <v-row class="mt-6">
      <v-col>
        <v-data-table
          v-model="selected"
          :search="search"
          :single-select="true"
          :items="allDocuments"
          :headers="headers"
          :options="options.sync"
          class="elevation-2"
          item-key="id"
          show-select
          :loading="isFetching || fetching"
          loading-text="Loading... Please wait"
          @contextmenu:row="show"
        >
          <template v-slot:[`item.transaction_id`]="{ item }">
            <span v-if="item.is_initiated && item.pendingForInitiate">
              <a style="text-decoration: none" @click="previewDocument(item)">
                {{item.transaction_id}}
              </a>
            </span>
            <span v-else>
              {{item.transaction_id}}
            </span>
          </template>
          <template v-slot:[`item.is_initiated`]="{ item }">
            <span v-if="!item.is_initiated && !item.pendingForInitiate">Pending</span>
            <span v-if="!item.is_initiated && item.pendingForInitiate">For Route</span>
            <span v-if="item.is_initiated && item.pendingForInitiate">Routed</span>
          </template>
          <template v-slot:[`item.initiate`]="{ item }">
            <span  v-if="item.is_initiated && item.pendingForInitiate"><a style="text-decoration: none" target="_blank" :href="'/routes/' + item.routes[0].id">View Route</a></span>
            <v-icon v-else @click="initiateToRouteRequest(item)">mdi-arrow-right</v-icon>
          </template>
          <template v-slot:[`item.overall_status`]="{ item }">
            <span v-if="item.is_initiated && item.pendingForInitiate"><a style="text-decoration: none" @click="openDialog(item.routes[0].id)">View Overall Status</a></span>
            <span v-else-if="!item.is_initiated && item.pendingForInitiate">Initiated</span>
            <span v-else>Not Initiated</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn class="mx-2"  color="success"><v-icon @click="editDocument(item)">mdi-pencil</v-icon></v-btn>
            <v-btn  color="error"><v-icon @click="deleteDocument(item)">mdi-trash-can</v-icon></v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <AddDocuments
      :dialog="dialog"
      :isStandalone="true"
      @closeDialog="closeDialog"
    />

    <UploadDocumentVersionDialog
      :dialog="manage_version_dialog"
      :documentId="select_version_id"
      :transactionId="select_version_transaction_id"
      @closeDialog="closeDocumentVersionManager"
    />

    <DocumentViewerDialog
      :dialog="viewer_dialog"
      :url="view_document_url"
      :type="view_document_type"
      :transactionId="view_document_tid"
      @closeDialog="closeViewerDialog"
    />
    <DocumentInitiateDetailsModal
      :dialog="initiateDialog"
      :document="selectedDocument"
      :addedReceivers="addedReceivers"
      @closeDialog="closeInititateModal"
    />
    <DocumentPreview
      :dialog="previewDialog"
      :document="selectedDocument"
      :addedReceivers="addedReceivers"
      @closeDialog="closePreviewModal"
    />
    <RouteLogTrackModal
      :dialog="route_log_dialog"
      :routeId="selected_log_id"
      :routeType="'mainroute'"
      @closeDialog="closeLog"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from "vuex";
  import AddDocuments from "../AddDocuments";
  import RouteModalCreate from "../RouteCreateModal";
  import UploadDocumentVersionDialog from "./UploadDocumentVersionDialog";
  import RouteLogTrackModal from "../routes/RouteLogTrackModal";
  // import Swal from "sweetalert2";
  import _ from "lodash";
  import moment from "moment";
  import { fileSystemUrl } from "../../config/config.json";
  import DocumentViewerDialog from "../common/DocumentViewerDialog";
  import DocumentInitiateDetailsModal from "./modal/DocumentInitiateDetailsModal.vue"
  import DocumentPreview from './modal/DocumentPreview.vue'
  import DropdownFilter from "./DropdownFilter.vue"
  export default {
    name: "DocumentList",
    props: {
      tableDisplay: String,
      // search: String,
      // dateRange: Object,
      // category: Array,
      type: Array,
      isFetching: Boolean,
      dialog: Boolean,
    },
    components: {
      AddDocuments,
      RouteModalCreate,
      UploadDocumentVersionDialog,
      DocumentViewerDialog,
      DropdownFilter,
      RouteLogTrackModal,
      DocumentInitiateDetailsModal,
      DocumentPreview
    },
    data() {
      return {
        route_log_dialog: false,
        selected_log_id: null,
        search: "",
        fetching: false,
        dateRange: {
          startDate: '',
          endDate: '',
        },
        category: [],
        types: [],
        showMenu: false,
        x: 0,
        y: 0,
        selected: [],
        singleSelect: false,
        headers: [
          { text: "Date", value: "date", sortable: true, align: "start" },
          { text: "Tracer No.", value: "transaction_id", align: "center" },
          { text: "Sender", value: "sender", align: "center" },
          { text: "Subject", value: "subject", align: "center" },
          {
            text: "Document Type",
            value: "document_type.name",
            align: "center",
          },
          {
            text: "Document Category",
            value: "document_category.name",
            align: "center",
          },
          { text: "Status", value: "is_initiated", align: "center" },
          { text: "Route", value: "initiate", align: "center" },
          { text: "Overall Status", value: "overall_status", align: "center" },
        ],
        options: {
          page: 1,
          itemsPerPage: 10,
          mustSort: true,
          groupBy: [],
          sortDesc: [false],
        },
        showSuccess: false,
        updateItem: null,
        route_dialog: false,
        showRouteSuccess: false,
        manage_version_dialog: false,
        select_version_id: null,
        select_version_transaction_id: null,
        viewer_dialog: false,
        initiateDialog: false,
        previewDialog: false,
        selectedDocument: {},
        view_document_type: null,
        view_document_url: "",
        view_document_tid: "",
      };
    },
    methods: {
      ...mapActions([
        "attachDocuments",
        "addInitiatedFromRoute",
        "initiateDocumentRouteRequest",
        "fetchDocuments",
        "fetchFilteredDocuments",
        "clearReceivers",
      ]),
      openDialog(id){
        this.selected_log_id = id
        this.route_log_dialog = true
      },
      closeLog(){
        this.route_log_dialog = false
      },
      applyFilter(filters){
        this.search = filters.search
        this.category = filters.category
        this.types = filters.types
        this.dateRange.startDate = filters.dateRange.startDate
        this.dateRange.endDate = filters.dateRange.endDate
        this.fetch()
      },
      archive() {
        alert("archving");
      },
      editDocument(document){
        alert(document)
      },
      deleteDocument(document){
        alert(document)
      },
      closeInititateModal(val){
        this.initiateDialog = val;
      },
      closePreviewModal(val){
        this.previewDialog = val;
      },
      closeDialog(val) {
        if (val) {
          this.showSuccess = true;
        }
        // this.dialog = false;
        this.$emit("closeDialog", false)
      },
      show(e) {
        e.preventDefault();
        this.showMenu = false;
        this.x = e.clientX;
        this.y = e.clientY;
        this.$nextTick(() => {
          this.showMenu = true;
        });
      },
      initiateToRouteRequest(document) {
        this.selectedDocument = document
        let arr = []
        arr.push(this.selectedDocument)
        this.attachDocuments(arr)
        this.initiateDialog = true;
      },
      previewDocument(document){
        this.selectedDocument = document
        let arr = []
        arr.push(this.selectedDocument)
        this.attachDocuments(arr)
        this.previewDialog = true;
      },
      closeRouteDialog(val) {
        if (val) {
          this.showRouteSuccess = true;
          this.addInitiatedFromRoute(this.selected);
        }
        this.route_dialog = false;
        this.selected = [];
      },
      timeout(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      },
      async viewDocuments() {
        if (this.selected.length > 1)
          alert("Select only one item to view document");
        else {
          let source = "";
          if (this.selected[0].document_instances) {
            if (this.selected[0].document_instances.length < 1)
              source = this.selected[0].filepath_url;
            else source = this.selected[0].document_instances[0].filepath_url;
          } else {
            source = this.selected[0].filepath_url; // only happens after creating a new one without refreshing
          }

          this.view_document_url = `${fileSystemUrl}/view/${source}`;
          this.view_document_type = this.selected[0].file_type;
          this.view_document_tid = this.selected[0].transaction_id;
          this.viewer_dialog = true;
        }
      },
      closeViewerDialog() {
        this.view_document_url = "";
        this.view_document_type = null;
        this.view_document_tid = "";
        this.viewer_dialog = false;
      },
      manageDocumentVersions() {
        if (this.selected.length > 1)
          alert("Please select only one item to manage version");
        else {
          this.manage_version_dialog = true;
          this.select_version_id = this.selected[0].id;
          this.select_version_transaction_id = this.selected[0].transaction_id;
        }
      },
      closeDocumentVersionManager() {
        this.manage_version_dialog = false;
      },
      fetch: _.debounce(async function() {
        this.fetching = true;
        let payload = {
          search: this.search != "" ? this.search : "",
          dateRange:
            this.dateRange.startDate != "" && this.dateRange.endDate != ""
              ? this.dateRange
              : { startDate: "January 01 , 1680", endDate: moment() },
          category: this.category,
          type: this.types,
          itemsPerPage: 10,
        };
        await this.fetchFilteredDocuments(payload).then(()=> {
          this.fetching = false;
        });
        this.scrollView()
      }, 300),
      scrollView(){
      if(window.location.hash) {
          var hash = window.location.hash.substring(1); 
          let sampledoc = this.allDocuments.filter(doc => doc.id == hash)
          this.selected = []
          this.selected.push(sampledoc[0])
      }
    }
    },
    computed: {
      ...mapGetters(["allDocuments", "addedReceivers"]),
      ...mapState({
        loading: (state) => state.documents.loading,
      }),
    },
    watch: {
      /* eslint-disable no-unused-vars */
      // Option Watch for server-side-pagination
      option: {
        async handler(newVal, oldVal) {
          const { sortBy, sortDesc, page, itemsPerPage } = newVal;
          let currentPage =
            typeof oldVal === "undefined" ? 1 : page === oldVal.page ? 1 : page;
          newVal.page = currentPage;
          await this.fetch({
            sortBy,
            sortDesc,
            page: currentPage,
            itemsPerPage,
          });
        },
        deep: true,
      },
      allDocuments: {
        async handler(newVal, oldVal){
          this.scrollView()
        }
      }
    },
    /* eslint-disable no-unused-vars */
  };
</script>

<style>
.v-input__control{
  margin-bottom: 5px;
}
  .list-item {
    cursor: pointer;
    font-size: 14px;
  }
  .v-data-table-header th {
    white-space: nowrap;
  }
  .flex-container {
  display: flex;
}
.flex-container > .flex-c{
  margin: 10px;
}
.calendars {
  flex-wrap: unset !important;
  margin: 0 auto;
}
.reportrange-text[data-v-79d7c92a] {
  display: none !important;
}
</style>
